var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading"},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"panel-body"},[_c('canvas',{ref:"chart",style:({height: '150px', width:'800px'})})])])}
var staticRenderFns = []

export { render, staticRenderFns }